import appnexus from './appnexus';
import noAppnexus from './appnexus/no';
import seAppnexus from './appnexus/se';

const commonConfig = {
  service: 'appnexus',
  appnexus,
  headerBiddingEnabled: false,
};

export const dk = { ...commonConfig };
export const es = { ...commonConfig };
export const fi = { ...commonConfig };
export const fr = { ...commonConfig, headerBiddingEnabled: true };
export const gb = { ...commonConfig, headerBiddingEnabled: true };
export const ie = { ...commonConfig };
export const it = { ...commonConfig };
export const no = { ...commonConfig, appnexus: noAppnexus };
export const nz = { ...commonConfig };
export const pl = { ...commonConfig };
export const se = { ...commonConfig, appnexus: seAppnexus };

export default {
  dk,
  es,
  fi,
  fr,
  gb,
  ie,
  it,
  no,
  nz,
  pl,
  se,
};
